import { ResultsTypes } from "@app/types/samples.types";
import { DEFAULT_CALCULATION_VALUES } from "./calculationConstants";

/**
 * Calcula los resultados consolidados
 */
export const calculateResults = (
  totalActivity?: number,
  totalUncertainty?: number,
  totalLid?: number,
  efficiencieTotal?: number,
  efficiencieMedia?: number
) => {
  return {
    totalActivity: totalActivity ?? DEFAULT_CALCULATION_VALUES.totalActivity,
    totalUncertainty: totalUncertainty ?? DEFAULT_CALCULATION_VALUES.totalUncertainty,
    totalLid: totalLid ?? DEFAULT_CALCULATION_VALUES.totalLid,
    efficiencieTotal: efficiencieTotal ?? DEFAULT_CALCULATION_VALUES.efficiencieTotal,
    efficiencieMedia: efficiencieMedia ?? DEFAULT_CALCULATION_VALUES.efficiencieMedia,
  };
};

/**
 * Calcula la eficiencia Sr89
 */
export const calculateEfficiencySr89 = (
  efficiencieTotal?: number,
  efficiencieMedia?: number
): string => {
  if (!efficiencieTotal || !efficiencieMedia) return "0";
  return ((efficiencieTotal / efficiencieMedia) * 100).toString();
};

/**
 * Construye el objeto ResultsTypes para guardar
 */
export const buildResultData = (
  formData: {
    to_report?: boolean;
    totalActivity?: number;
    totalUncertainty?: number;
    totalLid?: number;
  },
  efficiencies: {
    total?: number;
    media?: number;
  }
): ResultsTypes => {
  return {
    result: true,
    to_reports: formData.to_report ?? true,
    activity: formData.totalActivity?.toString() || "0",
    uncertainty: formData.totalUncertainty?.toString() || "0",
    lid: formData.totalLid?.toString() || "0",
    efficiency: efficiencies.total?.toString() || "0",
    efficiency_sr_89: calculateEfficiencySr89(efficiencies.total, efficiencies.media),
    inc_rel_squared_performance: efficiencies.media?.toString() || "0",
  };
};

/**
 * Extrae la clave del isotopo del tipo de isotopo
 */
export const extractIsotopeKey = (isotopeType: string): string => {
  if (!isotopeType) return "";
  
  return isotopeType.includes("+")
    ? isotopeType.split("+")[0].trim().toLowerCase()
    : isotopeType.trim().toLowerCase();
};

/**
 * Encuentra el trazador que coincide con el isotopo
 */
export const findMatchingTrazador = (
  trazadoresList: any[],
  isotopeKey: string
): any | null => {
  if (!isotopeKey || trazadoresList.length === 0) return null;
  
  return (
    trazadoresList.find(
      (t) => t.isotopo.trim().toLowerCase() === isotopeKey
    ) || null
  );
};

/**
 * Limpia el nombre del archivo de la ruta
 */
export const cleanFileName = (filePath?: string): string => {
  if (!filePath) return "";
  
  const fileName = filePath.split("/").pop();
  if (!fileName) return "";
  
  const lastUnderscoreIndex = fileName.lastIndexOf("_");
  if (lastUnderscoreIndex === -1) return fileName;
  
  const cleanName = fileName.substring(0, lastUnderscoreIndex) + ".RPT";
  return cleanName;
};
